<app-radio-paginated [searchSettings]="searchSettings"
                     [loaderId]="loaderId"
                     [totalCount]="totalCount"
                     [filter]="filter"
                     (search)="onSearch($event)"
                     [dataToView]="dataToView"
                     (nextData)="getNextData($event)">
</app-radio-paginated>